module.exports = __webpack_public_path__ + "a2314fc9/img/placeholder.888fcd0b.svg";